export default function cleanErrorMessage(e) {
  if (!e) return '';
  const msg = e.message || e.toString();
  return msg.replace(/^GraphQL error:\s*/, '');
}
